import { memo, type PropsWithChildren } from 'react'

import { SubSectionTitle } from '@/components/common/SubSectionTitle'

export interface MarketYourTransactionsLayoutProps extends PropsWithChildren {
  tableSettingsSlot?: React.ReactNode
}

const MarketYourTransactionsLayout = ({
  children,
  tableSettingsSlot
}: MarketYourTransactionsLayoutProps) => {
  return (
    <div className="gap-sm flex basis-[100%] flex-col">
      <div className="max-lg:gap-xs flex flex-row items-center justify-between max-lg:flex-col max-lg:items-start max-lg:justify-start">
        <SubSectionTitle>Your Transactions</SubSectionTitle>
        {tableSettingsSlot}
      </div>
      {children}
    </div>
  )
}
export default memo(MarketYourTransactionsLayout)
